import { Badge, Text } from "@chakra-ui/react";

export default function CardBadge({ props, isLowercase, bgColor }) {
  return (
    <Text
      display={"block"}
      bg={bgColor ?? "gray.500"}
      color={"white"}
      fontSize="lg"
      p="3px 10px"
      borderRadius="8px"
      border={"none"}
      fontWeight="normal"
      textTransform={isLowercase ? "lowercase" : "none"}
    >
      {props ?? "-"}
    </Text>
  );
}
